import { Skeleton } from '@/components/ui/skeleton';

export const AnalysisSkeleton = () => (
  <div className="space-y-4 animate-pulse">
    <div className="flex items-center gap-2">
      <Skeleton className="h-4 w-4 rounded" />
      <Skeleton className="h-5 w-32" />
    </div>
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-3/4" />
    <div className="space-y-3">
      {[1, 2, 3].map((i) => (
        <div key={i} className="p-3 bg-background rounded-lg border">
          <div className="flex items-center justify-between">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-5 w-16" />
          </div>
          <Skeleton className="h-4 w-24 mt-2" />
        </div>
      ))}
    </div>
  </div>
);
